import { EmptyState } from '@/components/ui/Feedback';
import { ButtonLink } from '@/components/ui/Button';
import { t } from '@/lib/i18n';
import { routes } from './paths';

/**
 * Temporary stand-in for a screen that a later phase will build. Says which phase, so a
 * half-built app is honest about what it is rather than looking broken.
 */
export function Placeholder({ title, phase }: { title: string; phase?: number }) {
  return (
    <EmptyState
      title={title}
      actions={
        <ButtonLink to={routes.home} variant="secondary" block children={t('common.backHome')} />
      }
    >
      {phase != null ? t('common.comingInPhase', { phase }) : t('common.notFound.body')}
    </EmptyState>
  );
}
